import {
  isTopicContentIntent,
  type TopicContentIntent,
} from "./topic-post-metadata";

export type CommunityIntentRecord = {
  metadata?: { contentIntent?: unknown } | null;
  location?: Record<string, unknown> | string | null;
};

export function getCommunityContentIntent(
  post: CommunityIntentRecord,
): TopicContentIntent | undefined {
  const metadataIntent = post.metadata?.contentIntent;
  if (typeof metadataIntent === "string" && isTopicContentIntent(metadataIntent)) {
    return metadataIntent;
  }

  const location = parseLocation(post.location);
  const locationIntent = location?.contentIntent;
  return typeof locationIntent === "string" && isTopicContentIntent(locationIntent)
    ? locationIntent
    : undefined;
}

export function getCommunityContentIntentLabel(
  intent: TopicContentIntent | undefined,
  locale: "ko" | "en" = "ko",
): string {
  if (intent === "question") return locale === "ko" ? "질문" : "Question";
  if (intent === "experience") return locale === "ko" ? "해결 경험" : "Solved experience";
  return locale === "ko" ? "동네 이야기" : "Neighbourhood story";
}

function parseLocation(
  value: CommunityIntentRecord["location"],
): Record<string, unknown> | null {
  if (!value) return null;
  if (typeof value === "object") return value;

  try {
    const parsed: unknown = JSON.parse(value);
    return parsed !== null && typeof parsed === "object" && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}
